/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateGroupImageUrlRequestFromJSON(json) {
    return StreemApiUpdateGroupImageUrlRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateGroupImageUrlRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'imageUrl': !exists(json, 'image_url') ? undefined : json['image_url'],
    };
}
export function StreemApiUpdateGroupImageUrlRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'image_url': value.imageUrl,
    };
}
//# sourceMappingURL=StreemApiUpdateGroupImageUrlRequest.js.map